// Resolve a display title from the legacy jsonb shape
// `[{ languageCode, text }, ...]`. Prefers 'en', falls back to first.
export const resolveTitle = (raw: unknown): string => {
  if (typeof raw === 'string') return raw;
  if (!Array.isArray(raw)) return '—';
  const en = raw.find(
    (e) =>
      e &&
      typeof e === 'object' &&
      'languageCode' in e &&
      'text' in e &&
      (e as { languageCode: string }).languageCode === 'en' &&
      typeof (e as { text: unknown }).text === 'string'
  );
  if (en) return (en as { text: string }).text || '—';
  const first = raw.find(
    (e) =>
      e &&
      typeof e === 'object' &&
      'text' in e &&
      typeof (e as { text: unknown }).text === 'string'
  );
  return first ? (first as { text: string }).text || '—' : '—';
};

export const formatLocation = (
  city: string | null | undefined,
  country: string | null | undefined
): string => {
  if (city && country) return `${city}, ${country}`;
  return city ?? country ?? '—';
};
